<script>
import { createGroup } from 'api/index'
import { getUrlParam, compareVersion } from 'common/js/common'
import { MessageBox } from 'bxs-ui-vue'
Vue.use(MessageBox)

const errorMsg = '微信或系统版本过低，请升级后再尝试'

export default {
  name: 'OpenLaunchWeapp',
  data () {
    return {
      roomId: ''
    }
  },
  created () {
    // iso15 && wx<8.0.8
    // 极少部分Android
    document.addEventListener('WeixinOpenTagsError', function (e) {
      console.error(e.detail.errMsg)
      this.$messagebox.alert(errorMsg)
    })
  },
  mounted () {
    if (this.versionAbnormal()) {
      this.$messagebox.alert(errorMsg)
    } else {
      this.init()
    }
  },
  methods: {
    async init () {
      try {
        await this.createRoom()
        this.createLaunchInfo()
      } catch (err) {
        console.log(err)
      }
    },
    // https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html#1
    versionAbnormal () {
      const ua = navigator.userAgent.toLowerCase()
      const isAndroid = window.appBridge && appBridge.isAndroid()
      const isIos = window.appBridge && appBridge.isIos()
      let wechatVersion, androidVersion, iosVersion
      wechatVersion = ua.match(/MicroMessenger\/([\d\.]+)/i)
      if (wechatVersion && wechatVersion[1]) {
        wechatVersion = wechatVersion[1]
      }
      // 微信版本要求为：7.0.12及以上
      if (compareVersion(wechatVersion, '7.0.12') === '<') {
        return true
      }
      if (isAndroid) {
        // Android version
        androidVersion = ua.match(/android (.*?);/)
        if (androidVersion && androidVersion[1]) {
          androidVersion = androidVersion[1].split('.')[0]
        }
        // Android 5.0及以上
        if (compareVersion(wechatVersion, '5.0') === '<') {
          return true
        }
      } else if (isIos) {
        // iOS version
        iosVersion = ua.match(/cpu iphone os (.*?) like mac os/)
        if (iosVersion && iosVersion[1] && iosVersion[1].split('_')) {
          iosVersion = iosVersion[1].split('_')[0]
        }
        // iOS 10.3及以上
        if (compareVersion(iosVersion, '10.3') === '<') {
          return true
        }
      }
      return false
    },
    createRoom () {
      const uuid = getUrlParam('uuid')
      return createGroup({ pbUuid: uuid }).then(
        ({ data: { data, success } } = { data: {} }) => {
          if (!success || !data) {
            this.$messagebox.alert('获取讲解房间号失败：', data)
            return
          }
          this.roomId = data
        }
      )
    },
    createLaunchInfo () {
      const width = (window.innerWidth - 30) + 'px'
      const content = `
        <button class="weapp-btn">确定</button>
        <style>
          .weapp-btn {
            display: block;
            width: ${width};
            padding: 7px 68px 8px;
            margin: 7px auto;
            color: #fff;
            font-size: 15px;
            font-weight: bold;
            text-align: center;
            border-radius: 6px;
            border: 0!important;
            outline: 0!important;
            background-color: #e58800;
          }
        </style>
      `
      const uuid = getUrlParam('uuid')
      const theme = getUrlParam('theme')
      const roomId = this.roomId
      const titleStr = '为您推荐计划书'
      const launchParams = {
        elmId: 'launch-wp',
        originalId: 'gh_db166d39960f',
        path: `pages/invitation/index?uuid=${uuid}&roomId=${roomId}&theme=${theme}&title=${titleStr}&app=tob`,
        content
      }
      this.wxLaunchBtn(launchParams)
    },
    wxLaunchBtn (info) {
      let btn = document.getElementById(info.elmId)
      let script = document.createElement('script')
      script.type = 'text/wxtag-template'
      script.text = info.content
      const wxHtml = `<wx-open-launch-weapp username="${
        info.originalId
      }" path="${info.path}">${script.outerHTML}</wx-open-launch-weapp>`
      btn.innerHTML = wxHtml
      btn.addEventListener('launch', function (e) {
        console.log('success')
      })
      // 点击跳转 抛出异常
      btn.addEventListener('error', function (e) {
        console.log('fail', e.detail)
      })
    }
  }
}
</script>
<template>
  <div id="launch-wp" />
</template>
<style lang="postcss" scoped>
</style>